
import { defineComponent, PropType } from 'vue';
import { mapState } from 'vuex';
import FiveStars from '@/components/FiveStars.vue';
import { useProcessAvatar } from '@/composables';
import { mapScoreToText } from '@/utils/rating';
import { Reaction, EmojiTable } from '@/components/reaction';
import { reactionClient } from '@/apis';
import { mockReaction } from '@/apis/mocks/reaction';
import { CardRatingItem } from './types';

export default defineComponent({
  components: {
    FiveStars,
    Reaction,
  },
  props: {
    /** 点评数据项 */
    rating: { type: Object as PropType<CardRatingItem>, required: true },
    showChat: { type: Boolean, default: false },
    showLike: { type: Boolean, default: false },
    showEdit: { type: Boolean, default: false },
    showDelete: { type: Boolean, default: false },
  },
  emits: [
    'click-avatar',
    'click-chat',
    'click-like',
    'click-edit',
    'click-delete',
  ],
  setup() {
    const { processAvatar } = useProcessAvatar();
    return {
      processAvatar,
    };
  },
  data() {
    return {
      mockReaction: {} as EmojiTable,
    };
  },
  computed: {
    ...mapState(['user']),
    timeDiff() {
      const res: string = this.rating.createdAt.fromNow();
      return res;
    },
    starColor(): string {
      return this.rating.starred ? '#ef755a' : '';
    },
  },
  created() {
    this.mockReaction = mockReaction.data.emoji;
  },
  methods: {
    handleAddReaction(emojiId: string) {
      reactionClient.addReaction({ uniId: 'uni-1', emojiId }).then(({ data }) => {
        this.mockReaction = { ...data.emoji };
      });
    },
    handleDeleteReaction(emojiId: string) {
      reactionClient.deleteReaction({ uniId: 'uni-1', emojiId }).then(({ data }) => {
        this.mockReaction = { ...data.emoji };
      });
    },
    mapScoreToText,
    /** 点击头像 */
    handleClickAvatar() {
      this.$emit('click-avatar', this.rating.creator.id);
    },
    /** 点击讨论 */
    handleClickChat() {
      this.$emit('click-chat', this.rating.id);
    },
    /** 点击收藏 */
    handleClickLike() {
      this.$emit('click-like', this.rating.id);
    },
    /** 点击修改 */
    handleClickEdit() {
      this.$emit('click-edit', this.rating.id);
    },
    /** 点击删除 */
    handleClickDelete() {
      this.$emit('click-delete', this.rating.id);
    },
  },
});
